module.exports = __webpack_public_path__ + "img/gallery01.cae647b9.jpg";